import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { InventorySyncPage } from '@/components/InventorySync/InventorySyncPage'
import { inventorySyncSearchSchema, withoutSearchDefaults } from '@/components/InventorySync/search'

/** Wiring only — see `organizations/index.tsx`. */
export const Route = createFileRoute('/_app/inventory-sync/')({
  validateSearch: inventorySyncSearchSchema,
  component: InventorySyncRoute,
})

function InventorySyncRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <InventorySyncPage
      search={search}
      onSearchChange={(next) =>
        void navigate({
          search: (current) => withoutSearchDefaults({ ...current, ...next }),
          // Opening a store or a run is going somewhere: push, so back returns.
          // Paging is where the user already is: replace.
          replace: next.page !== undefined && next.store === undefined && next.run === undefined,
        })
      }
    />
  )
}
